import {
  ButtonContext,
  DynamicListDataEntry,
  type DynamicListDataEntryProps,
} from '@axinom/mosaic-ui';
import React, { useMemo } from 'react';
import type { DeploymentData, ServiceDataTypes } from './RowExplorer.types';
import { useRowSelectExplorerModal } from './RowExplorerModel';

interface UseRowDataListDataEntryOptions {
  excludeItems: ServiceDataTypes[];
}

interface UseRowDataListDataEntryResult {
  RowDataListDataEntry: React.FC<DynamicListDataEntryProps<DeploymentData>>;
}

export const useRowDataListDataEntry = (
  options: UseRowDataListDataEntryOptions,
  type: string,
): UseRowDataListDataEntryResult => {
  const RowDataListDataEntry: React.FC<
    DynamicListDataEntryProps<DeploymentData>
  > = useMemo(() => {
    const RowDataListDataEntry: React.FC<
      DynamicListDataEntryProps<DeploymentData>
    > = (props) => {
      const { onActionClicked, ...rest } = props;
      const {
        ModalWrapper: RowSelectExplorerModal,
        openModal,
        closeModal,
      } = useRowSelectExplorerModal({
        excludeItems: options?.excludeItems?.map((item) => item?.name),
        onSelection: (selection) => {
          if (selection.mode === 'SINGLE_ITEMS') {
            const items = selection?.items;
            if (items && onActionClicked) {
              items.forEach((item) => onActionClicked(item));
            }
          }
          closeModal();
        },
        type,
      });

      return (
        <>
          <DynamicListDataEntry
            onActionClicked={() => openModal()}
            {...rest}
            actionButtonContext={ButtonContext.Active}
          />
          <RowSelectExplorerModal />
        </>
      );
    };

    return RowDataListDataEntry;
  }, [options?.excludeItems, type]);

  return { RowDataListDataEntry };
};
